/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let chatRoomCreatedUrl = root.chatRoomCreateUrl.link;
let UserChatListUrl = root.userChatListUrl.link;
let teamWorkspaceUrl = root.teamWorkspaceUrl.link;
let UserChatDetailsUrl = root.userChatDetailsUrl.link;
let AdminChatDetailsUrl = root.adminChatDetailsUrl.link;
let ChatConnectionRequestUrl = root.chatConnectionRequestUrl.link;
let MsgReadStatusUrl = root.msgReadStatusUrl.link;
let NormalOrgListUrl = root.normalOrgListUrl.link;
let ApporveChatRequestUrl = root.apporveChatRequestUrl.link;
let NormalChatListUrl = root.normalChatListUrl.link;
let OrgConnectionReqListUrl = root.orgConnectionReqListUrl.link;
let UserChatReqListUrl = root.userChatReqListUrl.link;
let UploadMsgFileUrl = root.uploadMsgFileUrl.link;
let RequestApprovedURl =  root.requestApprovedUrl.link;
let ChatBrowserNotificationtUrl =  root.chatBrowserNotificationtUrl.link;
let userSearchForChatURL =  root.userSearchForChatUrl.link;
let roomMeetingIdValidURL =  root.roomMeetingIdValidUrl.link;
let userSupportHelpApiURL =  root.userSupportHelpApiUrl.link;
let groupChatListApiURL = root.groupChatListApiUrl.link;
let getGroupChatDetailsApiURL = root.getGroupChatDetailsApiUrl.link;
let leaveGroupRoomApiURL = root.leaveGroupRoomApiUrl.link;
let updateGroupRoomDetailsApiURL = root.updateGroupRoomDetailsApiUrl.link;
let getGroupDetailsByIdApiURL = root.getGroupDetailsByIdApiUrl.link;
let makeUserToGroupAdminApiURL = root.makeUserToGroupAdminApiUrl.link;
let userRemovedFromGroupApiURL = root.userRemovedFromGroupApiUrl.link;
let removedAdminFromGroupApiUrl = root.removedAdminFromGroupApiUrl.link;


export default {
  state: {
    userChatListState:{},
    teamWorkspaceState:{},
    getUserChatDetailsState:{},
    chatConnectionRequestListState:{},
    normalUserOrgListState:{},
    orgConnectionReqListState:{},
    userChatRequestListState:{},
    getUserListByOrgState:{},
    ChatBrowserNotificationtState:{},
    getGroupChatListState:{}
  },
  mutations: {
    getGroupChatListMut(state, value) {
      Vue.set(state, 'getGroupChatListState', value);
    },
    userChatListMut(state, value) {
      Vue.set(state, 'userChatListState', value);
    },
    teamWorkspaceMut(state, value) {
      Vue.set(state, 'teamWorkspaceState', value);
    },
    getUserChatDetailsMut(state, value) {
      Vue.set(state, 'getUserChatDetailsState', value);
    },
    chatConnectionRequestListMut(state, value) {
      Vue.set(state, 'chatConnectionRequestListState', value);
    },
    normalUserOrgListMut(state, value) {
      Vue.set(state, 'normalUserOrgListState', value);
    },
    orgConnectionReqListMut(state, value) {
      Vue.set(state, 'orgConnectionReqListState', value);
    },
    userChatRequestListMut(state, value) {
      Vue.set(state, 'userChatRequestListState', value);
    },
    getUserListByOrgMut(state, value) {
      Vue.set(state, 'getUserListByOrgState', value);
    },
    ChatBrowserNotificationtMuatation(state, value){
      Vue.set(state, 'ChatBrowserNotificationtState', value);
    },
  },
  actions: {
    // Remove Admin From Group
    removedAdminFromGroupFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(removedAdminFromGroupApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Make Group Api
    removedUserFromGroupAdminFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(userRemovedFromGroupApiURL + payload.data.id + '/',payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Make Group Api
    makeGroupAdminFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(makeUserToGroupAdminApiURL,payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Group Chat Room List
    getGroupChatDetailsByIdFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(getGroupDetailsByIdApiURL + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Group Details Fun
    updateGroupChatDetailsFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(updateGroupRoomDetailsApiURL + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Leave Group Chat Room Of List
    leaveRoomGroupByIdFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(leaveGroupRoomApiURL, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Group Chat Room List
    getGroupChatDetailsFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(getGroupChatDetailsApiURL + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Group Chat Room List
    getGroupChatRoomCreatedFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(groupChatListApiURL, payload).then(res => {
              context.commit('getGroupChatListMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Chat Room Create
    chatRoomCreatedFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(chatRoomCreatedUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get User Chat List Create
    adminChatListFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(UserChatListUrl, payload).then((res) => {
          context.commit('userChatListMut', res.data);
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Get Admin Chat List Create
    getAdminChatDetailsByIdFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(AdminChatDetailsUrl + payload.id + '/', payload).then((res) => {
          context.commit('getUserChatDetailsMut', res.data);
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Get User Chat List Create
    getUserChatDetailsByIdFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(UserChatDetailsUrl + payload.id + '/', payload).then((res) => {
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Get User Support Help Chat List
    getUserSupportHelpChatDetailsByIdFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(userSupportHelpApiURL + payload.id + '/', payload).then((res) => {
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // MSg Read Status Function
    msgReadStatusFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(MsgReadStatusUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // MSg Read Status Function
    chatConnectionRequestListFun(context, payload) {
        return new Promise((resolve, reject) => {
          axios.get(ChatConnectionRequestUrl, payload).then((res) => {
            context.commit('chatConnectionRequestListMut', res);
            resolve(res);
          }).catch((err)=>{
            reject(err);
          })
        })
    },
    // MSg Read Status Function
    SendChatConnectionRequestFun(context, payload) {
        return new Promise((resolve, reject) => {
          axios.post(ChatConnectionRequestUrl, payload).then((res) => {
            resolve(res);
          }).catch((err)=>{
            reject(err);
          })
        })
    },
    // Get User Chat List Create
    teamWorkspaceFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(teamWorkspaceUrl, payload).then((res) => {
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Get User List By Organization Create
    getUserListByOrgFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(teamWorkspaceUrl + payload.id + '/').then((res) => {
          context.commit('getUserListByOrgMut', res.data);
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Get Normal Chat List Create
    normalChatListFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(NormalChatListUrl, payload).then((res) => {
          context.commit('teamWorkspaceMut', res.data);
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Get User Chat List Create
    normalUserOrgListFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(NormalOrgListUrl, payload).then((res) => {
          context.commit('normalUserOrgListMut', res.data);
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Confirm Request Status Function
    SendChatConnectionRequestApprovedFun(context, payload) {
        return new Promise((resolve, reject) => {
          axios.post(ApporveChatRequestUrl, payload).then((res) => {
            resolve(res);
          }).catch((err)=>{
            reject(err);
          })
        })
    },
    // Get Organization Connection Request List
    orgConnectionReqListFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(OrgConnectionReqListUrl + payload.id + '/').then((res) => {
          context.commit('orgConnectionReqListMut', res.data);
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Get User Chat Request List
    userChatRequestListFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(UserChatReqListUrl + payload.id + '/').then((res) => {
          context.commit('userChatRequestListMut', res.data);
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Upload Msg File In chat
    uploadMsgFileInChatFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.post(UploadMsgFileUrl, payload).then((res) => {
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Chat Request Apporved
    apporvedConnectionRequestFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.patch(RequestApprovedURl + payload.data.id + '/', payload.data.data).then((res) => {
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Browser Notification
    chatBroserNotificationFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.get(ChatBrowserNotificationtUrl, payload).then((res) => {
          context.commit('ChatBrowserNotificationtMuatation', res.data);
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // User Search For Chat
    userSearchForNewChatFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.post(userSearchForChatURL, payload).then((res) => {
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
    // Room Valid Id 
    checkRoomValidIdFun(context, payload){
      return new Promise((resolve, reject) =>{
        axios.post(roomMeetingIdValidURL, payload).then((res) => {
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      })
    },
  },
  getters: {
    userChatListGetters: state => state.userChatListState,
    teamWorkspaceGetters: state => state.teamWorkspaceState,
    getUserChatDetailsGetters :state => state.getUserChatDetailsState,
    chatConnectionRequestListGetters: state => state.chatConnectionRequestListState,
    normalUserOrgListGetter: state => state.normalUserOrgListState,
    orgConnectionReqListGetters: state => state.orgConnectionReqListState,
    userChatRequestListGetters: state => state.userChatRequestListState,
    getUserListByOrgGetters: state => state.getUserListByOrgState,
    workspaceUserNotificationGetters: state => state.ChatBrowserNotificationtState,
    getGroupChatListGetter: state => state.getGroupChatListState
  }
}